export default __webpack_public_path__ + "assets/images/11e2a51cd4495ef4788ab1a17eeb9559.svg";